import { createTopic, ConfigActions } from '../lib';
import { z } from 'zod';

const marketplaceSystemNavigatedEventSchema = z.object({
  entityUrn: z.string().describe('The URN of the system.'),
  path: z
    .string()
    .describe('The navigated path to the system in the marketplace.'),
});

export type MarketplaceSystemNavigatedEvent = z.infer<
  typeof marketplaceSystemNavigatedEventSchema
>;

export const marketplaceSystemNavigatedTopic =
  createTopic<MarketplaceSystemNavigatedEvent>(
    {
      namespace: 'marketplace',
      name: 'system-navigated',
      description: 'User navigated to a system in the marketplace.',
    },
    marketplaceSystemNavigatedEventSchema,
    s => [{ action: ConfigActions.HASH, path: s.entityUrn }],
  );
